import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function AnimatedSection({
  children,
  className = '',
  animationClass = 'animate-fade-up',
  delayClass = ''
}: {
  children: React.ReactNode;
  className?: string;
  animationClass?: string;
  delayClass?: string;
}) {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <div ref={ref as React.RefObject<HTMLDivElement>} className={`transition-all duration-1000 ease-out ${className} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${delayClass}`} data-id="element-15">
      {children}
    </div>;
}